/**
 * TypeScript types for processing rules management.
 */

export interface ProcessingRule {
  id: number;
  agent_type: string;
  rule_text: string;
  rule_priority: number;
  is_active: boolean;
  document_type: string | null;
  source_type: string | null;
  carrier_code: string | null;
  customer_ref_code: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface RuleFilters {
  agent_type?: string;
  is_active?: boolean;
  document_type?: string;
  source_type?: string;
  carrier_code?: string;
  customer_ref_code?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

export interface RuleCreateData {
  agent_type: string;
  rule_text: string;
  rule_priority: number;
  is_active: boolean;
  document_type?: string | null;
  source_type?: string | null;
  carrier_code?: string | null;
  customer_ref_code?: string | null;
}

export interface RuleUpdateData {
  rule_text?: string;
  rule_priority?: number;
  is_active?: boolean;
  document_type?: string | null;
  source_type?: string | null;
  carrier_code?: string | null;
  customer_ref_code?: string | null;
}

export interface RuleListResponse {
  rules: ProcessingRule[];
  total: number;
  limit: number;
  offset: number;
}

export interface CarrierOption {
  id: number;
  ref_carrier_code: string | null;
  name: string | null;
  ref_scac_id: string | null;
}

export interface CustomerOption {
  id: number;
  ref_client_code: string | null;
  name: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  zip_code: string | null;
}

export interface CarrierListResponse {
  carriers: CarrierOption[];
}

export interface CustomerListResponse {
  customers: CustomerOption[];
}

export type AgentType = "classifier" | "extractor" | "matcher" | "validator";

export const AGENT_TYPES: AgentType[] = ["classifier", "extractor", "matcher", "validator"];

export const AGENT_TYPE_LABELS: Record<AgentType, string> = {
  classifier: "Classifier",
  extractor: "Extractor",
  matcher: "Matcher",
  validator: "Validator",
};

export const AGENT_TYPE_DESCRIPTIONS: Record<AgentType, string> = {
  classifier: "Categorizes incoming documents by type (BOL, DR, Invoice, etc.)",
  extractor: "Extracts structured data fields from document content",
  matcher: "Matches extracted data against existing shipment records",
  validator: "Validates extracted data for accuracy and completeness",
};

export const DOCUMENT_TYPES = ["BOL", "DR", "INVOICE", "AT"] as const;

export const SOURCE_TYPES = [
  "maven",
  "agent_ftp",
  "agent_merge",
  "driver_app",
  "idoc_admin",
  "email",
] as const;
